"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListNotificationsResponseDto = instanceOfListNotificationsResponseDto;
exports.ListNotificationsResponseDtoFromJSON = ListNotificationsResponseDtoFromJSON;
exports.ListNotificationsResponseDtoFromJSONTyped = ListNotificationsResponseDtoFromJSONTyped;
exports.ListNotificationsResponseDtoToJSON = ListNotificationsResponseDtoToJSON;
exports.ListNotificationsResponseDtoToJSONTyped = ListNotificationsResponseDtoToJSONTyped;
var NotificationDto_1 = require("./NotificationDto");
/**
 * Check if a given object implements the ListNotificationsResponseDto interface.
 */
function instanceOfListNotificationsResponseDto(value) {
    if (!('items' in value) || value['items'] === undefined)
        return false;
    if (!('nextCursor' in value) || value['nextCursor'] === undefined)
        return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined)
        return false;
    return true;
}
function ListNotificationsResponseDtoFromJSON(json) {
    return ListNotificationsResponseDtoFromJSONTyped(json, false);
}
function ListNotificationsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'items': (json['items'].map(NotificationDto_1.NotificationDtoFromJSON)),
        'nextCursor': json['nextCursor'],
        'hasMore': json['hasMore'],
    };
}
function ListNotificationsResponseDtoToJSON(json) {
    return ListNotificationsResponseDtoToJSONTyped(json, false);
}
function ListNotificationsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'items': (value['items'].map(NotificationDto_1.NotificationDtoToJSON)),
        'nextCursor': value['nextCursor'],
        'hasMore': value['hasMore'],
    };
}
